export const UPLOAD_IMAGES_STEP = 1
export const RECOGNIZED_WINE_STEP = 2

export const STEPS = {
  uploadImages: UPLOAD_IMAGES_STEP,
  recognizedWine: RECOGNIZED_WINE_STEP,
}
export const FIELDS = {
  BOTTLE_IMAGES: 'bottleImages',
  ADDITIONAL_IMAGES: 'additionalImages',
  RECOGNITION_DATA: 'recognitionData',
}
